import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

export const Root = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    min-width: 0;
  `,
);

export const TitleRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    min-width: 0;

    @media (max-width: ${theme.sz.lg}) {
      flex-wrap: wrap;
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: 0;
    ${theme.typography.heading.desktop.xs};
    color: ${theme.co.secondary20};
    line-height: 1.3;

    @media (max-width: ${theme.sz.lg}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const Duration = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
    margin-left: auto;
    flex: none;
    white-space: nowrap;
    ${theme.typography.paragraph.s};
    font-weight: ${theme.DEPRECATED_ty.semiBold};
    color: ${theme.co.secondary50};

    svg {
      width: ${theme.sz.s4};
      height: ${theme.sz.s4};
      flex: none;
    }

    @media (max-width: ${theme.sz.lg}) {
      margin-left: 0;
    }
  `,
);

export const Hint = styled.p(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    margin: 0;
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary50};

    svg {
      width: ${theme.sz.s4};
      height: ${theme.sz.s4};
      flex: none;
    }
  `,
);

export const WordList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
    min-width: 0;
  `,
);

export const WordRow = styled.div<{ $isSelected: boolean }>(
  ({ theme, $isSelected }) => css`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
    padding: ${theme.sz.s2} ${theme.sz.s3};
    border: ${theme.bo.mediumWidth} solid ${$isSelected ? theme.co.primary20 : 'transparent'};
    border-radius: ${theme.bo.medium};
    background-color: ${$isSelected ? theme.co.primary95 : theme.co.neutral99};
    text-align: left;
    cursor: pointer;
    transition:
      background-color 150ms ease,
      border-color 150ms ease;

    html[data-color-scheme='dark'] & {
      background-color: ${
        $isSelected
          ? transparentize(0.4, theme.co.primary95)
          : transparentize(0.62, theme.co.neutral99)
      };
    }

    &:hover {
      background-color: ${$isSelected ? theme.co.primary95 : theme.co.secondary99};
      border-color: ${$isSelected ? theme.co.primary20 : theme.co.secondary95};

      html[data-color-scheme='dark'] & {
        background-color: ${
          $isSelected
            ? transparentize(0.4, theme.co.primary95)
            : transparentize(0.5, theme.co.secondary99)
        };
      }
    }

    @media (max-width: ${theme.sz.lg}) {
      gap: ${theme.sz.s2};
      padding: ${theme.sz.s2};
    }
  `,
);

export const WordText = styled.div(
  () => css`
    min-width: 0;
  `,
);

export const WordTerm = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    font-weight: ${theme.DEPRECATED_ty.bold};
    color: ${theme.co.secondary20};
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
);

export const WordGloss = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary50};
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
);

export const Stages = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.sz.s1};
    width: auto;
    min-width: ${theme.sz.s26};
    flex: none;

    @media (max-width: ${theme.sz.lg}) {
      min-width: 0;
    }
  `,
);

export const StagesBar = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s1};
  `,
);

export const StageSeg = styled.span<{ $isOn: boolean }>(
  ({ theme, $isOn }) => css`
    width: ${theme.sz.s4};
    height: ${theme.sz.s1};
    border-radius: ${theme.bo.round};
    background-color: ${$isOn ? theme.co.primary20 : theme.co.secondary95};

    @media (max-width: ${theme.sz.lg}) {
      width: ${theme.sz.s3};
    }
  `,
);
